import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(theme => ({
  container: {
    width: '100%',
    height: '100%',
    overflow: ({ isAnimating }) => (isAnimating ? 'hidden' : 'auto'),
    position: 'relative',
    ...theme.globalStyles.scrollbar(theme),

    '& .slide-wrapper': {
      width: '100%',
      height: '100%',
      position: 'absolute',
    },
  },
}));

export default styles;
